<section class="py-3">
  <div class="container-fliud card">
    <div class="row align-items-center justify-content-between g-2 mb-2 pt-3">
      <div class="col-12 col-md-5">
        <app-main-heading [heading]="'Vehicle Make'" class="m-0"></app-main-heading>
      </div>
      <div class="col-12 col-md-7">
        <div class="row g-2 align-items-center justify-content-end">
          <div class="col-6 col-md-5 col-lg-4">
            <div class="search-wrapper position-relative w-100">
              <input
                type="text"
                class="form-control search-input"
                placeholder="Search..."
                style="border-radius: 8px; padding-left: 35px; height: 38px; border: 1.5px solid #E2E8F0; font-size: 13px;"
                #searchTerm
                (input)="FilterList(searchTerm.value)">
              <fa-icon [icon]="faSearch" class="position-absolute start-0 top-50 translate-middle-y ms-3 text-muted" style="pointer-events: none; font-size: 13px;"></fa-icon>
            </div>
          </div>
          <div class="col-auto">
            <button class="btn app-btn-primary w-100" style="height: 38px; display: flex; align-items: center; justify-content: center;" (click)="vehicleMakeFormPopup('Add')">Add Vehicle</button>
          </div>
        </div>
      </div>
    </div>
    <div class="card app-table-thick-border shadow-none mb-2">
      <div class="table-responsive app-scrollbar" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300" (scrolled)="loadMore()">
        <table class="table app-table-rounded align-middle m-0 w-100">
          <thead>
            <tr class="app-table-header">
              <th scope="col" sortable="">Name</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            @if (makeList.length > 0) {
              @for (list of makeList; track list) {
                <tr class="app-table-body app-td-text">
                  <td class="td-text-three">{{list.name}}</td>
                  <td>
                    <fa-icon class="btn app-btn-primary btn-sm" (click)="vehicleMakeFormPopup('update',list)" [icon]="faEdit" size="lg"
                    ngbTooltip="Edit" [placement]="'right'"></fa-icon> &nbsp;
                  </td>
                </tr>
              }
            }

            @if (loader) {
              <tr>
                <td colspan="2">
                  <div class="custom-col-width-100 d-flex justify-content-center py-5">
                    <app-loader [loadingIcon]="loader"></app-loader>
                  </div>
                </td>
              </tr>
            }

            @if (!loader && makeList.length === 0) {
              <tr>
                <td colspan="2">
                  <div class="custom-col-width-100 text-danger d-flex justify-content-center py-5 fw-semibold">
                    No Records Found!
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>



  @if (showEditMakePopup) {
    <div class="popup-overlay">
      <div class="popup-container">
        <h3>{{popupType}} Vehicle Make</h3>
        <form [formGroup]="vehicleMakeForm" (ngSubmit)="onEditSubmit()">
          <div class="row pt-2 g-2">
            <div class="col-12 mb-2">
              <label for="name" class="form-label">Name<span class="text-danger">*</span></label>
              <input formControlName="name" id="name" type="text" class="form-control default-form-group-border" required
                placeholder="Enter name*">
                @if (
                  vehicleMakeForm.get('name')?.invalid &&
                  vehicleMakeForm.get('name')?.touched
                  ) {
                  <div>
                    <small class="text-danger">Name is required</small>
                  </div>
                }
              </div>
              @if (errorMessage) {
                <div class="text-danger mb-2">{{errorMessage}}</div>
              }
            </div>
            <!-- Action Buttons -->
            <div class="row pt-3">
              <div class="col-12 d-flex justify-content-end gap-2">
                <button type="button" class="btn pr-2" (click)="closePopup()">Cancel</button>
                <button type="submit" class="btn app-btn-primary sub_button" [disabled]="vehicleMakeForm.invalid">
                  {{this.popupType}}
                  @if (isLoading) {
                    <output class="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output>
                  }
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    }
  </section>

  @if (isToster) {
    <app-toaster [title]="message" (closeToaster)="closeToster($event)" ></app-toaster>
  }